module.exports = __webpack_public_path__ + "img/medical-cross.7f2c8819.svg";